import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import { LOGIN_ROUTE } from "../../config/RoutesConstants";
import { 
  reduxForm, 
} from "redux-form";
 
import { 
  typeInteger, 
} from "../../common/Validations"; 
import {
  Container,
  Badge,
  Box,
  Button, 
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  IconButton,
  InputLabel,
  Grid,
  Paper,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell, 
  TablePagination,
  Typography, 
  Tooltip,
  Input,
  InputAdornment, 
  SvgIcon,
  Select,
  Toolbar,
  MenuItem,
  Tab,
  Tabs,
} from "@material-ui/core";
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
 
import { withTheme } from "@material-ui/core/styles";
import BackIcon from "@material-ui/icons/ArrowBackRounded";
import SearchIcon from "@material-ui/icons/Search";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete"; 
import ExcelTemplateIcon from "@material-ui/icons/CloudDownload";
import ErrorIcon from '@material-ui/icons/Error';
import GiftIcon from "@material-ui/icons/CardGiftcard";
import Util, {
  ERROR,
  SUCCESS,
  WARNING, 
} from "../../common/Util";
import {
  actionSaveTickets,
  actionSaveTicketsMassive,
  actionGetTicketTypes,
  actionCreateTicketsProcess,
  actionGetTicketsProcess,
  actionDeleteTicketProcess,
  actionGiftTicketProcess,
  actionGiftAllTicketProcess,
  actionAddTicketsProcessByEmailOrDU,
  actionAddTicketsProcessFromExcel,
} from "../../actions/EventActions";
import {
  actionGetUsersByEmailOrDU,
  actionGetUsersFromExcel,
} from "../../actions/UserActions";
import Setting from "../../provider/base/Settings";

let _handleSubmitFail;


const TABLE_TAB_REGISTERED = 0;
const TABLE_TAB_UNREGISTERED = 1;

const COD_ERROR_01 = "El cliente excede la cantidad de tickets permitido por persona"; 
const COD_ERROR_02 = "El cliente se encuentra duplicado en el Excel"; 

class AddEditTicket extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { 
      ticketTypeSel: "", 
      searchField: "DU",
      search: "",
      tabSel: 0,
      userSel: null,
      page: 0,
      rowPerPage: 5,
      count: 0,
      ticketTypeError: "",
      duError: "", 
      tableTabSel: TABLE_TAB_REGISTERED,
      ticketCount: 1,
      ticketCountError: "",
      alignment: "left", 
      showTicketsErrorsOnly: false
    };
    this.getTycketTypeSuccess = this.getTycketTypeSuccess.bind(this);
    this.onChangeSearch = this.onChangeSearch.bind(this);
    this.onChangeTicketType = this.onChangeTicketType.bind(this);
    this.onChangeCount = this.onChangeCount.bind(this);
    this.onChangePage = this.onChangePage.bind(this);
    this.onChangeRowsPerPage = this.onChangeRowsPerPage.bind(this);
    this.onSearchUser = this.onSearchUser.bind(this);
    this.onClean = this.onClean.bind(this);
    this.onSave = this.onSave.bind(this);
    this.renderListForm = this.renderListForm.bind(this);
    this.renderIndividualForm = this.renderIndividualForm.bind(this);
    this.onSearchUserCallback = this.onSearchUserCallback.bind(this);
    this.renderTableBody = this.renderTableBody.bind(this);
     
    this.isValidSearch = this.isValidSearch.bind(this);
    this.isValidForm = this.isValidForm.bind(this);
    this.onClickUploadExcel = this.onClickUploadExcel.bind(this);
    this.onUploadExcel = this.onUploadExcel.bind(this); 
    this.onGiftAllTicket = this.onGiftAllTicket.bind(this); 
    _handleSubmitFail = this.handleSubmitFail.bind(this);
    this.handleAlignment = this.handleAlignment.bind(this);
    this.getTicketType = this.getTicketType.bind(this);
    this.validateMaxTicketQt = this.validateMaxTicketQt.bind(this);
    this.onResultUploadExcel = this.onResultUploadExcel.bind(this);
    this.existTicketErrors = this.existTicketErrors.bind(this);
    this.onChangeShowTicketsError = this.onChangeShowTicketsError.bind(this);
    this.inputFile;

    this.alignment = 'left';
  }

  componentWillMount() {
    if (!this.props.login) {
      this.props.history.replace(LOGIN_ROUTE);
    }
    this.props.actionGetTicketTypes(
      this.getTycketTypeSuccess,
      this.getTicketsError,    
    );

    //Llamamos a la creacion de un proceso de tickets, se guarda en el store. (LO PODRIAMOS SETEAR EN EL STATE.)
    this.props.actionCreateTicketsProcess(this.onChangePage,
                                    ()=>{});
                                    
  }

 

  onChangeRowsPerPage(evt) { 
    this.setState({
      rowPerPage: evt.target.value, 
    });
  }

  getTycketTypeSuccess() {
    if (this.props.ticketTypeList && this.props.ticketTypeList > 0) {
      this.setState({ ticketTypeSel: this.props.ticketTypeList[0] });
    }
  }

  handleSubmitFail(error) {
    console.log("ERROR EN EL SUBMIT", error);
  }

  // Devuelve un objeto de ticketType a partir de su id
  getTicketType(tktTypeId){ 
    if (this.props.ticketTypeList && this.props.ticketTypeList.length > 0) {
        for (let i = 0; i < this.props.ticketTypeList.length; i++){ 
            if (this.props.ticketTypeList[i].id == tktTypeId) 
                return this.props.ticketTypeList[i];
        }
    }
    return {};
  }


  onChangePage(evt = null, newPage = 0) { 

    let filter = {
                  processId : this.props.ticketsProcessId, //TODO Asignar bien el processId
                  onlyRegistered : this.state.tableTabSel == TABLE_TAB_REGISTERED,
                  onlyUnregistered: this.state.tableTabSel == TABLE_TAB_UNREGISTERED,
                  onlyErrors:   this.state.showTicketsErrorsOnly 
                }; 
    let order = {
      "field": "dni",
      "desc": false
    };
    let limit = {
      "from": newPage * this.state.rowPerPage,
      "size": this.state.rowPerPage
    };


    this.props.actionGetTicketsProcess(filter, order, limit, () => { this.setState({ page: newPage, })});
      
      
  }

  onClean() {

    // Vamos a te

    // Regeneramos el id de TicketProcess y el viejo queda descartado.
    // Al retornar limpia todo el estado
    this.props.actionCreateTicketsProcess(()=>
            this.setState({ 
              ticketTypeSel: "", 
              searchField: "DU",
              search: "",
              tabSel: 0,
              userSel: null,
              page: 0,
              rowPerPage: 5,
              count: 0, 
              ticketTypeError: "",
              duError: "",
              tableTabSel: TABLE_TAB_REGISTERED,
              ticketCount: 1,
              ticketCountError: "",
              showTicketsErrorsOnly: false
            }, this.onChangePage), // Y al finalizar actualiza la tabla
            ()=>{}); 
  }

  isValidForm() {
    let isValid = true;

    

    /*if (
      (!this.state.isMassive && !this.state.usersData) ||
      (!this.state.isMassive &&
        this.state.usersData.users.length == 0 &&
        this.state.usersData.usersToInvite.length == 0)
    ) {
      Util.showNoty(ERROR, "Debe agregar tickets");
      isValid = false;
    }*/ //TODO, revisar esta validación, podria ser por backend
    return isValid;
  }

  onSave() {
    if (this.isValidForm()) { 
      
      
      let errorsQt =  this.props.ticketsProcessList.qtUnregisterErrors + this.props.ticketsProcessList.qtRegisterErrors;

      //TODO, utilizar otro Confirm a Nivel UI
      if ((errorsQt > 0 && window.confirm("Existen tickets con error, desea procesar igualmente ignorando los tickets erroneos?") || errorsQt == 0)) {
        
        this.props.actionSaveTicketsMassive(
          this.props.event.id,
          this.props.ticketsProcessId,
          (response) => {
             
            if (response.result == 'ERROR'){
                
                let errorMsg = '';
                for (let i = 0; i < response.errors.length; i++) {
                  // Accede al elemento actual utilizando array[i]
                    errorMsg = errorMsg + response.errors[i] + '\n';
                }
                Util.notyError(errorMsg);
            }else if (response.result == 'OK'){

                let successMessage = null;
                if (response.cantTicketsOK > 0){
                    if (response.cantTicketsOK == 1)
                        successMessage = 'Se generó 1 ticket para usuario registrado';
                    else
                        successMessage = `Se generaron ${response.cantTicketsOK} tickets para usuarios registrados`;
                }
                if (response.cantInvitationsOK > 0){
                    
                        if (successMessage != null)
                            successMessage += '\n'
                        else
                            successMessage = '';

                        if (response.cantInvitationsOK == 1)
                            successMessage += 'Se generó 1 invitación para usuario no registrado';
                        else
                            successMessage += `Se generaron ${response.cantInvitationsOK} invitaciones para usuarios no registrados`;
                    
                }
                  
                Util.notySuccessPersist(successMessage);
                
                this.props.history.goBack();
            }
          },
          (e) => {
            Util.showNoty(ERROR, "No se pudo guardar el/los ticket/s.");
          }
        ); 
    }
    }
  }


  // Valida que no se exceda la cantidad maxima permitida para este tipo de ticket
  // Se valida en Front y despues tambien en back
  validateMaxTicketQt(quantity){
    
    if (this.state.ticketTypeSel && quantity > this.state.ticketTypeSel.tktMaxQtBuy)
        return `El tipo de ticket seleccionado solo admite ${this.state.ticketTypeSel.tktMaxQtBuy} ticket por usuario`

    return null;
  }


  isValidSearch() {
    let isValid = true;
    if (!this.state.ticketTypeSel) {
      this.setState({ ticketTypeError: "Debe seleccionar un tipo de ticket" });
      isValid = false;
    }
    if (
      !this.state.ticketCount ||
      typeInteger(this.state.ticketCount) ||
      this.state.ticketCount <= 0
    ) {
      this.setState({
        ticketCountError: "Debe ingresar un valor numérico positivo",
      });
      isValid = false;
    }

    if (isValid){ // No valida si ya en este punto esta incorrecto
        let messageMaxTicketQt = this.validateMaxTicketQt(this.state.ticketCount);
        if (messageMaxTicketQt != null){
            Util.showNoty(ERROR, messageMaxTicketQt);
            isValid = false;
        }
    }

    let dus = this.state.search && this.state.search.split(",");
    if (dus) {
      let wrongDUs = "";
      for (let i = 0; i < dus.length; i++) {
        let du = dus[i];
        
        if (!/^[a-zA-Z0-9]*$/.test(du)) {
          let errorDU = "El formato del documento es incorrecto. Solo letras y numeros";
          wrongDUs += wrongDUs ? dus[i] : errorDU + " " + dus[i];
          isValid = false;
        }
      }
      this.setState({ duError: wrongDUs });
    } else {
      this.setState({
        duError: "Debe ingresar al menos un número de documento.",
      });
      isValid = false;
    }

    return isValid;
  }

  onSearchUser() {
    if (this.isValidSearch()) {
      let usersDU = this.state.search;
      this.props.actionAddTicketsProcessByEmailOrDU(
        usersDU,
        "", // Email no se esta usando
        this.props.event.id,
        this.props.ticketsProcessId,  
        this.state.ticketTypeSel.id,
        this.state.ticketCount,
        this.onSearchUserCallback,
        (e) => {
          console.log("ERROR ON SEARCH USER", e);
          if (!(e && e.status && e.status == 401))
            Util.showNoty(ERROR, "No se encontró el usuario.");
        }
      );
    }
  }

  onChangeTicketType(evt) {
    
    let type = evt.target.value;

    this.setState({
      ticketTypeSel: type,
      ticketTypeError: ""
    });
  }

  onChangeSearch(evt) {
    let txt = evt.target.value || "";
    this.setState({ search: txt.trim(), duError: "" });
  }

  onChangeCount(evt) {
    this.setState({ ticketCount: evt.target.value, ticketCountError: "" });
  }

  onUploadExcel(evt) {
    evt.preventDefault();
    let f = evt.target.files[0]; 
    if (f) {
      this.props.actionAddTicketsProcessFromExcel(
        f,
        this.props.event.id,
        this.props.ticketsProcessId,  
        this.state.ticketTypeSel.id,
        this.state.ticketCount,
        this.onResultUploadExcel, 
        (e) => {
          console.log("ERROR", e);
        }
      );
    }
    evt.target.value = "";
  }

  onResultUploadExcel(response){

      if (response && response.errorMessage){
          Util.showNoty(ERROR, response.errorMessage);
          return;
      }else{
          this.onChangePage(); // Para refrescar la tabla
      }
  }

  onClickUploadExcel(evt) {
    if (this.state.ticketTypeSel) {
      this.inputFile && this.inputFile.click();
    } else {
      this.setState({ ticketTypeError: "Debe seleccionar un tipo de ticket" });
    }
  }

  onSearchUserCallback(data) {
  
    if (data && data.errorMessage){ 
        Util.showNoty(ERROR, data.errorMessage);
        return;
    } 

    // Limpia el campo de busqueda
    this.setState({ search: ""}, this.onChangePage);

  }

   

  onDeleteTicket(item) { 
    // Llama al Action para eliminar el registro.
     
    this.props.actionDeleteTicketProcess(item.id, () => {Util.showNoty(SUCCESS, "Se elimino el registro exitosamente");
                                                         this.onChangePage(null, this.state.page);}); //al volver refresca la pagina para que se vea el cambio
     
  }

  onGiftTicket(item) {

    let isGiftParam = true;
    if (item.isGift == 1) // Si actualmente ya esta marcado como regalo, entonces le quita la marca
        isGiftParam = false;

    this.props.actionGiftTicketProcess(item.id, isGiftParam,  () => {this.onChangePage(null, this.state.page)}); //al volver refresca la pagina para que se vea el cambio
 
  }

  // Marca todos los tickets de usuarios como regalos.
  onGiftAllTicket(giftAll) { //Recibe una bandera que indica si debe marcar todos como regalo, o desmarcar todos los regalos.
 
    let onlyRegistered = false;
    
    if (this.state.tableTabSel == TABLE_TAB_REGISTERED)
        onlyRegistered = true; // Si estamos parados en el tab de usuarios registrados, marcamos los mismos.

    this.props.actionGiftAllTicketProcess(this.props.ticketsProcessId, onlyRegistered, giftAll,  () => {this.onChangePage(null, this.state.page)});

  }

  renderIndividualForm() {
    const { theme, ticketTypeList } = this.props;
    return (
      <form style={theme.paper.form}>
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <FormControl
              fullWidth
              error={this.state.ticketTypeError ? true : false}
            >
              <InputLabel shrink fullWidth>
                Tipo de ticket
              </InputLabel>
              <Select
                onChange={this.onChangeTicketType}
                fullWidth
                value={this.state.ticketTypeSel}
              >
                {ticketTypeList &&
                  ticketTypeList.map((c) => {
                    return <MenuItem value={c}>{c.tktDisplayName}</MenuItem>;
                  })}
              </Select>
              <FormHelperText>{this.state.ticketTypeError}</FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={8}>
            <FormControl fullWidth error={this.state.duError ? true : false}>
              <InputLabel shrink fullWidth>
                Usuario
              </InputLabel>
              <Input
                fullWidth 
                onChange={this.onChangeSearch}
                value={this.state.search}
                startAdornment={
                  <InputAdornment position="start">
                    <Typography>DU</Typography>
                  </InputAdornment>
                }
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton onClick={this.onSearchUser}>
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                }
              />
              <FormHelperText>{this.state.duError}</FormHelperText>
            </FormControl>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          {this.state.ticketTypeSel && (
            <Grid item xs={4}>
              <Typography>
                Valor: {Util.formatCurrency(this.state.ticketTypeSel.tktPrice)}
              </Typography>
              <Typography>
                Categoría: {this.state.ticketTypeSel.tktCategory}
              </Typography>
            </Grid>
          )}
          {this.state.userSel && (
            <Grid item xs={8}>
              <Typography>
                Nombre: {this.state.userSel.proName}{" "}
                {this.state.userSel.proLastName}
              </Typography>
              <Typography>E-mail: {this.state.userSel.proEmail} </Typography>
              <Typography>DU: {this.state.userSel.proDNI} </Typography>
            </Grid>
          )}
        </Grid>
      </form>
    );
  }


  renderTicketTypeToGenerate() {
    const { theme, ticketTypeList } = this.props; 
    return (
      <form style={theme.paper.form}>
        <Grid container spacing={2}>
          <Grid item xs={3}>
            <FormControl
              fullWidth
              error={this.state.ticketTypeError ? true : false}
            >
              <InputLabel shrink fullWidth>
                Tipo de ticket
              </InputLabel>
              <Select
                onChange={this.onChangeTicketType}
                fullWidth
                value={this.state.ticketTypeSel}
                defaultValue=""
                displayEmpty={true}
              >
                <MenuItem value="">
                  <em>Seleccionar</em>
                </MenuItem>
                {ticketTypeList &&
                  ticketTypeList.map((c) => {
                    return <MenuItem value={c}>{c.tktDisplayName}</MenuItem>;
                  })}
              </Select>
              <FormHelperText>{this.state.ticketTypeError}</FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={2}>
            <FormControl
              fullWidth
              error={this.state.ticketCountError ? true : false}
            >
              <InputLabel shrink fullWidth>
                Cantidad
              </InputLabel>
              <Input
                fullWidth
                onChange={this.onChangeCount}
                value={this.state.ticketCount}
              />
              <FormHelperText>{this.state.ticketCountError}</FormHelperText>
            </FormControl>
          </Grid> 
        </Grid> 
      </form>
    );
  }



  renderManual() {
    const { theme, ticketTypeList } = this.props; 
    return (
      <form style={theme.paper.form}>
        <Grid container spacing={2}>
          
          
          <Grid item xs={5}>
            <FormControl fullWidth error={this.state.duError ? true : false}>
              <InputLabel shrink fullWidth>
                Usuario
              </InputLabel>
              <Input
                fullWidth
                onChange={this.onChangeSearch} 
                value={this.state.search}
                startAdornment={
                  <InputAdornment position="start">
                    <Typography>DU</Typography>
                  </InputAdornment>
                }
              />
              <FormHelperText>{this.state.duError}</FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={1}>
            <Tooltip title={this.tabSel ? "Agregar tickets" : "Buscar usuario"}>
              <IconButton onClick={this.onSearchUser}>
                <AddIcon />
              </IconButton>
            </Tooltip>
          </Grid> 
        </Grid> 
      </form>
    );
  }

  renderCargaExcel() {
    const { theme, ticketTypeList } = this.props; 
    return (
      <form style={theme.paper.form}>
        <Grid container spacing={2}> 
        

         <Grid item xs={1}>
           <input
             type="file"
             ref={(r) => {
               this.inputFile = r;
             }}
             style={{ display: "none" }}
             accept=".xlsx"
             onChange={this.onUploadExcel}
           />
           <Tooltip title="Cargar excel">
             <IconButton onClick={this.onClickUploadExcel}>
               <SvgIcon viewBox="0 0 384 512">
                 <path
                   fill="currentColor"
                   d="M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm212-240h-28.8c-4.4 0-8.4 2.4-10.5 6.3-18 33.1-22.2 42.4-28.6 57.7-13.9-29.1-6.9-17.3-28.6-57.7-2.1-3.9-6.2-6.3-10.6-6.3H124c-9.3 0-15 10-10.4 18l46.3 78-46.3 78c-4.7 8 1.1 18 10.4 18h28.9c4.4 0 8.4-2.4 10.5-6.3 21.7-40 23-45 28.6-57.7 14.9 30.2 5.9 15.9 28.6 57.7 2.1 3.9 6.2 6.3 10.6 6.3H260c9.3 0 15-10 10.4-18L224 320c.7-1.1 30.3-50.5 46.3-78 4.7-8-1.1-18-10.3-18z"
                 />
               </SvgIcon>
             </IconButton>
           </Tooltip>
           <Tooltip title="Template excel">
             <IconButton href={Setting.EXCEL_TEMPLATE}>
               <ExcelTemplateIcon />
             </IconButton>
           </Tooltip>
         </Grid>
       </Grid>
      </form>
    );
  }



  existTicketErrors(){
    if (this.props.ticketsProcessList){ 
      if (this.props.ticketsProcessList.qtRegisterErrors > 0 || this.props.ticketsProcessList.qtUnregisterErrors > 0)
          return true;
    }
    return false;
  }


  //

  onChangeShowTicketsError(){ 
      this.setState({showTicketsErrorsOnly: !this.state.showTicketsErrorsOnly}, this.onChangePage);
  }
   
  renderListForm() {
    const { theme, ticketTypeList } = this.props;

    let isGiftAllInvitation = false;
    let isGiftAllRegistered = false; 

    if (this.props.ticketsProcessList){
        if (this.props.ticketsProcessList.qtRegister == this.props.ticketsProcessList.qtRegisterGifts)
            isGiftAllRegistered = true;
        if (this.props.ticketsProcessList.qtUnregister == this.props.ticketsProcessList.qtUnregisterGifts)
            isGiftAllInvitation = true; 
    }
     
    
    return (
      <form style={theme.paper.form}> 
          <Grid container spacing={2}>
            <Grid
                container
                direction="row"
                
              >
            <Tabs
              indicatorColor="primary"
              textColor="primary"
              value={this.state.tableTabSel}
              onChange={(evt, v) => {
                this.setState({ tableTabSel: v }, this.onChangePage);
              }}
            >
              <Tab value={0} label="Registrados" style={{ minWidth: 0 }}></Tab>
              <Tooltip
                title={
                  this.props.ticketsProcessList &&
                  ((this.props.ticketsProcessList.qtRegisterTickets == 1
                    ? `${this.props.ticketsProcessList.qtRegisterTickets} ticket`
                    : `${this.props.ticketsProcessList.qtRegisterTickets} tickets`)
                  + ((this.props.ticketsProcessList.qtRegisterErrors > 0) ? ` / ${this.props.ticketsProcessList.qtRegisterErrors} con error`
                    : '')
                  )
                }
              >
                <Badge
                  badgeContent={this.props.ticketsProcessList.qtRegisterTickets}
                  color="primary"
                  style={{ marginTop: 10, marginRight: 10 }}
                ></Badge>
              </Tooltip>

              {this.props.ticketsProcessList && this.props.ticketsProcessList.qtRegister > 0 && (
                <Tooltip
                  title={
                    isGiftAllRegistered
                      ? "Cobrar todos los registrados"
                      : "Invitar a todos los  registrados"
                  }
                >
                  <IconButton
                    onClick={() => {
                      this.setState({ tableTabSel: TABLE_TAB_REGISTERED },() => this.onGiftAllTicket(!isGiftAllRegistered));
                    }}
                  >
                    <GiftIcon
                      style={isGiftAllRegistered ? { color: "orange" } : undefined}
                    />
                  </IconButton>
                </Tooltip>
              )}
              <Tab
                value={1}
                label="No Registrados" 
                style={{ minWidth: 0 }}
              ></Tab>
              <Tooltip
                title={ 
                  this.props.ticketsProcessList &&
                  ((this.props.ticketsProcessList.qtUnregisterTickets == 1
                    ? `${this.props.ticketsProcessList.qtUnregisterTickets} invitación`
                    : `${this.props.ticketsProcessList.qtUnregisterTickets} invitaciones`)
                  + ((this.props.ticketsProcessList.qtUnregisterErrors > 0) ? ` / ${this.props.ticketsProcessList.qtUnregisterErrors} con error`
                  : '')
                  )
                  }>  
                <Badge
                  badgeContent={this.props.ticketsProcessList.qtUnregisterTickets}
                  color="primary"
                  style={{ marginTop: 10, marginRight: 10 }}
                ></Badge>
              </Tooltip>
              {this.props.ticketsProcessList && this.props.ticketsProcessList.qtUnregister > 0 && (
                <Tooltip
                  title={
                    isGiftAllInvitation
                      ? "Cobrar todos los no registrados"
                      : "Invitar a todos los no registrados"
                  }
                >
                  <IconButton
                    onClick={() => {
                      this.setState({ tableTabSel: TABLE_TAB_UNREGISTERED }, () => this.onGiftAllTicket(!isGiftAllInvitation));
                    }}
                  >
                    <GiftIcon
                      style={
                        isGiftAllInvitation ? { color: "orange" } : undefined
                      }
                    />
                  </IconButton>
                </Tooltip>
              )}
            </Tabs>

            {this.existTicketErrors() ?  
                  <Tooltip title={(this.props.ticketsProcessList.qtRegisterErrors + this.props.ticketsProcessList.qtUnregisterErrors) + ' tickets erróneos' }>
                    <FormControlLabel
                      control={
                        <Checkbox
                          onChange={this.onChangeShowTicketsError}
                          checked={this.state.showTicketsErrorsOnly} 
                          color="primary"
                        /> 
                      }
                      label="Mostrar solo tickets erroneos"
                    /> 
                  </Tooltip>
            : null} 

            </Grid>

            <Table stickyHeader>
              <TableHead>{this.renderTableHeader()}</TableHead>
              <TableBody>{this.renderTableBody()}</TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 100]}
              component="div"
              count={this.state.tableTabSel == TABLE_TAB_REGISTERED ? this.props.ticketsProcessList.qtRegister : this.props.ticketsProcessList.qtUnregister}
              rowsPerPage={this.state.rowPerPage}
              page={this.state.page}
              onChangePage={this.onChangePage}
              onChangeRowsPerPage={this.onChangeRowsPerPage}
            />
          </Grid>
        
      </form>
    );
  }

  renderTableHeader() {
    const { theme } = this.props;
    let headers = [
      "Tipo de Ticket",
      "Categoría",
      "E-mail",
      "DNI",
      "Nombre y Apellido",
      "Cantidad",
      "Valor",
      "Total",
    ];
    if (this.state.tableTabSel) {
      headers = [
        "Tipo de Ticket",
        "Categoría",
        "E-mail",
        "DNI",
        "Cantidad",
        "Valor",
        "Total",
      ];
    }
    return (
      <TableRow>
        {headers.map((label) => {
          return <TableCell>{label}</TableCell>;
        })}
        {this.existTicketErrors() ? <TableCell>Error</TableCell> : null} 
        <TableCell style={theme.table.actionsColumn}>Acciones</TableCell>
      </TableRow>
    );
  }

  renderTableBody() {
    const { theme } = this.props; 
    let tickets = this.props.ticketsProcessList.items; 

    if (!tickets || tickets.length == 0) {
      return (
        <Box style={theme.table.empty}>
          Seleccione el tipo de ticket y el/los usuario/s para agregar tickets
        </Box>
      );
    }
    return tickets.map((item, index) => { 

      let price = item.isGift == 1 ? 0 : this.getTicketType(item.tktType).tktPriceProducer; //TODO es precio de proudctor?
      return (
        <TableRow
          style={index % 2 == 0 ? theme.table.row : theme.table.rowColor}
        >
          <TableCell>{this.getTicketType(item.tktType).tktDisplayName}</TableCell>
          <TableCell>{this.getTicketType(item.tktType).tktCategory}</TableCell>
          <TableCell>{item.email}</TableCell>
          <TableCell>{item.dni}</TableCell>
          {this.state.tableTabSel == TABLE_TAB_UNREGISTERED ? null : (
            <TableCell>
              {item.proName} {item.proLastName}
            </TableCell>
          )}
          <TableCell>{Util.formatNumber(item.quantity)}</TableCell>
          <TableCell>{Util.formatCurrency(price)}</TableCell>
          <TableCell>{Util.formatCurrency(price * item.quantity)}</TableCell>
          {!this.existTicketErrors() ? null :
            (item.error ? 
              <TableCell><Tooltip title={item.error == 1 ? COD_ERROR_01 : (item.error == 2 ? COD_ERROR_02 : '') }><ErrorIcon></ErrorIcon></Tooltip></TableCell>
            :
              <TableCell></TableCell>
            )
          }  
          <TableCell style={{ ...theme.table.actionsColumn, minWith: 200 }}>
            <Tooltip title={item.isGift == 1 ? "Cobrar ticket" : "Regalar ticket"}>
              <IconButton onClick={this.onGiftTicket.bind(this, item, index)}>
                <GiftIcon style={item.isGift == 1 ? { color: "orange" } : undefined} />
              </IconButton>
            </Tooltip>
            <Tooltip title="Eliminar ticket">
              <IconButton onClick={this.onDeleteTicket.bind(this, item)}>
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          </TableCell>
        </TableRow>
      );
    });
  }
  
 handleAlignment(event, newAlignment)  { 
    this.setState({ alignment: newAlignment });
   
};

  render() {
    const { theme, handleSubmit, event, ticketFormValues } = this.props;
    return (
      <Box style={theme.mainContainer}>
        <Box
          style={{
            ...theme.title.container,
            flexDirection: "row",
            display: "flex",
          }}
        >
          <Box style={theme.title.backIconContainer}>
            <Tooltip title="Atrás">
              <IconButton
                onClick={this.props.history.goBack}
                style={theme.title.backIcon}
              >
                <BackIcon
                  style={{ fontSize: "2.5rem" }}
                  stroke="white"
                  strokeWidth={3}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </IconButton>
            </Tooltip>
          </Box>
          <Box>
            <Typography variant="h1">{event && event.evtName}</Typography>
            <Typography variant="subtitle1">
              Crea tickets para el evento seleccionado
            </Typography>
          </Box>
        </Box>
        <Container>
          <Paper>
            <Box style={theme.paper.addEditTicketTypeTitle}>
              <Typography style={theme.paper.title} variant="h2">
                Crear ticket
              </Typography>
              <Typography style={theme.paper.title} variant="h2">
                Fecha del evento:{" "}
                {event &&
                  Util.formatDateToShow(
                    Util.timestampToMoment(event.evtDateTime)
                  )}
              </Typography>
            </Box>


            
            <ToggleButtonGroup
              value={this.state.alignment}
              exclusive 
              aria-label="text alignment"
              onChange={this.handleAlignment}
            >
              <ToggleButton value="left" aria-label="left aligned">
                Manual
              </ToggleButton>
              <ToggleButton value="center" aria-label="centered">
                Cargar Excel
              </ToggleButton>
            {/* <ToggleButton value="right" aria-label="right aligned">
                Carga Masiva
                          </ToggleButton>*/ }
            </ToggleButtonGroup>

            {this.renderTicketTypeToGenerate()}
            
            
            {this.state.alignment == 'left' ? this.renderManual() : null}
            {this.state.alignment == 'center' ? this.renderCargaExcel(): null}
            {this.renderListForm()}
          </Paper>
          <Toolbar style={theme.footer.toolbar}>
            <Tooltip title="Limpiar">
              <Button
                variant="contained"
                color="secondary"
                style={theme.footer.button}
                onClick={this.onClean}
              >
                Limpiar
              </Button>
            </Tooltip>
            <Tooltip title="Cancelar">
              <Button
                variant="contained"
                color="secondary"
                style={theme.footer.button}
                onClick={this.props.history.goBack}
              >
                Cancelar
              </Button>
            </Tooltip>
            <Tooltip title="Guardar">
              <Button
                variant="contained"
                color="primary"
                style={theme.footer.button}
                onClick={handleSubmit(this.onSave)}
              >
                Guardar
              </Button>
            </Tooltip>
          </Toolbar>
        </Container>
      </Box>
    );
  }
}
function mapStateToProps(store) { 
  return {
    login: store.auth.login,
    event: store.evt.event,
    ticketFormValues:
      store.form && store.form.addEditTicket && store.form.addEditTicket.values,
    ticketTypeList: store.evt.ticketTypeList,
    ticketsProcessList : store.evt.ticketsProcessList,
    ticketsProcessId : store.evt.ticketsProcessId,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      actionGetTicketTypes,
      actionCreateTicketsProcess,
      actionGetTicketsProcess,
      actionDeleteTicketProcess,
      actionGiftTicketProcess,
      actionGiftAllTicketProcess,
      actionAddTicketsProcessByEmailOrDU,
      actionAddTicketsProcessFromExcel,
      actionSaveTickets,
      actionSaveTicketsMassive, 
      actionGetUsersByEmailOrDU,
      actionGetUsersFromExcel,
    },
    dispatch
  );
}

export default reduxForm({
  form: "addEditTicket",
  onSubmitFail: (errors) => _handleSubmitFail(errors),
})(
  withRouter(
    withTheme(connect(mapStateToProps, mapDispatchToProps)(AddEditTicket))
  )
);



// WEBPACK FOOTER //
// ./src/screens/events/AddEditTicket.js